
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-touring",
      function () {
        return require("private-next-pages/motorcycle-touring.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorcycle-touring"])
      });
    }
  